import { RecaptchaType } from '@/models/enums';

export enum RecaptchaBadgePosition {
  BottomLeft = 'bottomleft',
  BottomRight = 'bottomright'
}

export class RecaptchaResult {
  recaptchaType: RecaptchaType;
  recaptchaToken: string = '';
  isSucceeded: boolean = false;
  isCancelled: boolean = false;
  isError: boolean = false;
  errorDescription: string = '';

  constructor(recaptchaType: RecaptchaType) {
    this.recaptchaType = recaptchaType;
  }
}
